module.exports = __webpack_public_path__ + "assets/e7e687f1a39b2a5e497ea756f6eb4409.png";